export const USER_LOGOUT = (values) => dispatch => {
  dispatch({
    type: 'USER_LOGOUT',
    payload: values
  })
}